export const GoogleMapApiConfig = 'AIzaSyCQaBEIe_KR4HuaFW8jEUckY1uTY0wqkdw';